export default __webpack_public_path__ + "static/media/tires_icon.30c3bacc.svg";